import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import {
  groupRoles,
  groupPrivacyStatusDesc,
  groupERGcategories,
  validate_val,
  createGroupMember,
  profilePicValidityCheck,
} from "../../../utils/constants";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import Select from "react-select";
import { createGrpStyle } from "./GrpSelectStyles";
import { Alert } from "reactstrap";
import AutocompleteAddress from "../../../components/AddressSearch/AutocompleteAddress";
import EventsMap from "../../../components/AddressSearch/EventsMap";

class GroupMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      privacy: null,
      description: "",
      invitedUsers: [],
      errors_array: [],
      users: [],
      isCatErr: false,
      searchedUser: "",
      date: new Date(),
      removeUsers: [],
      description: "",
      selectedCategories: [],
      groupCategories: groupERGcategories,
      isDescErr: false,
      address: "",
      location: {
        type: "Point",
        coordinates: [0, 0],
      },
      welcomeMessage:"",
      isWelcomeMsgErr:false
    };
    this.timer = null;
  }

  changeGroupName = (event) => {
    let { name } = this.state;
    const { value } = event.target;
    let obj = { name: value };
 
      this.setState(obj);
      this.props.changeGroupName(value);

    // else {
    //   this.setState
    // }
  };

  changePrivacy = (value) => {
    // console.log('privacy---', value)
    if (value) {
      let id = typeof value == "object" ? value.id : value;
      // let{id}=value
      this.setState({ privacy: id });
      this.props.changePrivacy(id);
    }
  };

  assignedUserDelay = ({ target }) => {
    const { value } = target;
    this.setState({ searchedUser: value });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  };

  handleAssignUser = (value) => {
    if (value && value.length > 0) {
      let payload = {
        name: value,
        removeUsers: this.state.removeUsers,
        noLoader: true,
        isGroup: false,
      };

      axios.post(url.searchUsers, payload).then((resp, idx) => {
        let users = resp.data.data;

        if (users.length == 0) {
          users = "No users were found";
        }

        this.setState({ users });
      });
    } else {
      this.setState({ users: [] });
    }
  };

  assignedUserFormat = (selectedUser) => {
    let { removeUsers, date } = this.state;

    if (
      removeUsers.indexOf(selectedUser._id) == -1 ||
      removeUsers.length == 0
    ) {
      let userId = selectedUser._id;
      let organizationId = selectedUser.organizationId;
      // delete selectedUser._id
      // delete selectedUser.organizationId
      let u = createGroupMember(
        selectedUser,
        this.props.user.profile._id,
        date,
        "Member"
      );
      console.log("u-----", u);

      let invitedUsers = this.state.invitedUsers.concat(u);

      this.setState((prevState) => ({
        invitedUsers,
        removeUsers: prevState.removeUsers.concat(selectedUser._id),
        users: [],
        searchedUser: "",
      }));
      this.props.handleInvitedUsers(invitedUsers.length);
    }
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  validateGrp = () => {
    let { description, name } = this.state,
      { bannerImg, user } = this.props,
      errors_array = [];

    if (validate_val(description)) {
      errors_array.push("Description is missing");
    }
    if (validate_val(name)) {
      errors_array.push("Name is missing");
    }
    if (name.length > 75) {
      errors_array.push("Name cant be greater than 75 chars.");
    }

    if (validate_val(bannerImg)) {
      errors_array.push("Image is missing");
    }

    this.setState({ errors_array });

    return errors_array;
  };

  createGroup = () => {
    let errors = [];
    errors = this.validateGrp();

    if (errors.length == 0) {
      let {
        name,
        privacy,
        invitedUsers,
        selectedCategories,
        date,
        description,
        address,
        location,
        welcomeMessage
      } = this.state;
      let { bannerImg, user } = this.props;

      privacy = privacy.id ? privacy.id : privacy;

      let current_u = createGroupMember(
        user.profile,
        user.profile._id,
        date,
        "Admin"
      );

      let members = [current_u, ...invitedUsers];

      let payload = {
        name,
        privacy,
        members,
        bannerImg,
        categories: selectedCategories,
        description,
        createdOn: date,
        address,
        location,
        welcomeMessage:welcomeMessage
      };
      let that = this;

      const formData = new FormData();

      formData.append("payload", JSON.stringify(payload));

      if (bannerImg && bannerImg.file) {
        formData.append("uploads", bannerImg.file);
      }

      axios
        .post(url.createGroup, formData)
        .then(({ data }) => {
          let groupId = data.data._id;
          let url = `/home/groups/${user.profile.organizationId._id}/view/${groupId}`;
          that.props.history.push({ pathname: url });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // 1px solid #ced0d4a6 !important
  removeUser = (user) => {
    // console.log('user---', user)
    let { invitedUsers, removeUsers } = this.state;
    invitedUsers = invitedUsers.filter((e) => e.o_id != user.o_id);
    removeUsers = removeUsers.filter((e) => e != user.o_id);
    this.setState({ invitedUsers, removeUsers });
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // this.handleSubmitTodo();
      // e.preventDefault();
    }
  };

  handleGrpDesc = ({ target }) => {
    let { description } = this.state;
    const { value } = target;
    description = value;

    let obj = { description };

    if (description.length > 200) {
      obj = { ...obj, isDescErr: true };
      // this.setState({isDescErr:true})
    } else {
      obj = { ...obj, isDescErr: false };
    }

    this.setState(obj);
    this.props.handleGrpDesc(description);
  };
  
  handleGrpWelcomeMessage = ({ target }) => {
    let { welcomeMessage } = this.state;
    const { value } = target;
    welcomeMessage = value;

    let obj = { welcomeMessage };

    if (welcomeMessage.length > 200) {
      obj = { ...obj, isWelcomeMsgErr: true };
      // this.setState({isDescErr:true})
    } else {
      obj = { ...obj, isWelcomeMsgErr: false };
    }

    this.setState(obj);
    this.props.handleGrpWelcomeMessage(welcomeMessage);
  };

  handleGrpWelcomeMessage = ({ target }) => {
    let { welcomeMessage } = this.state;
    const { value } = target;
    welcomeMessage = value;

    let obj = { welcomeMessage };

    if (welcomeMessage.length > 200) {
      obj = { ...obj, isWelcomeMsgErr: true };
      // this.setState({isDescErr:true})
    } else {
      obj = { ...obj, isWelcomeMsgErr: false };
    }

    this.setState(obj);
    this.props.handleGrpWelcomeMessage(welcomeMessage);
  };

  addGroupCategory = (selectedCategories) => {
    if (selectedCategories != 4) {
      let res = selectedCategories.map((e) => e.id);
      groupERGcategories.filter((e) => res.indexOf(e.id) == -1);
      this.setState({
        selectedCategories,
        groupCategories: groupERGcategories,
        isCatErr: false,
      });
    } else {
      this.setState({
        isCatErr: true,
      });
    }
  };

  goBack = () => {
    this.props.history.push(
      `/home/groups/${this.props.user.profile.organizationId._id}/discover`
    );
  };

  render() {
    let {
      name,
      privacy,
      invitedUsers,
      users,
      searchedUser,
      groupCategories,
      selectedCategories,
      isDescErr,
      isCatErr,
      errors_array,
      description,
      welcomeMessage,
      isWelcomeMsgErr
    } = this.state;
    let { user, bannerImg } = this.props;

    let isCreate =
      (name != "") & (privacy != null) && isDescErr != true ? true : false;
    // console.log('invitedUsers: ', invitedUsers)
    return (
      <div className="col-md-2 col-lg-2 side-navbar-bg custom_left_menu creatingGroup boxShadow1">
        <div className="sidebar-category-section custom_left_menu_section">
          <span
            className="grp_create_menu_go_back"
            onClick={() => this.goBack()}
          >
            {"<< Back"}
          </span>
          <div className="sidebar-menuItem custom_left_menu_section_menuItem">
            Create Group
          </div>

          <div className="custom_left_menu_user_container">
            {profilePicValidityCheck(user.profile.profilePic) ? (
              <img
                className="custom_left_menu_user_profilePic"
                src={user.profile.profilePic}
              />
            ) : (
              <span data-letters={this.getInitials(user.profile)}></span>
            )}
            <span className="custom_left_menu_user_details">
              <span className="custom_left_menu_user_name">
                {user.profile.firstName} {user.profile.lastName}
              </span>
              <span className="custom_left_menu_user_role">Admin</span>
            </span>
          </div>
        </div>

        <div className="custom_left_section_menu_fields">
          <div className="floating-label-group">
            <input
              type="text"
              id="name"
              className="form-control"
              onChange={this.changeGroupName}
              value={name}
              placeholder=" "
              autoComplete="off"
            />
            <label className="floating-label">
              {" "}
              Name{" "}
              {name.length > 0
                ? ` (${name.length}/75 char)`
                : "(max 75 char)"}{" "}
            </label>
          </div>

          <div className="floating-label-group">
            <Select
              name="kpi-select"
              placeholder={""}
              value={privacy}
              simpleValue
              isOpen={true}
              getOptionLabel={({ name }) => name}
              getOptionValue={({ id }) => id}
              onChange={this.changePrivacy}
              options={groupPrivacyStatusDesc}
              valueKey="id"
              labelKey="name"
              styles={createGrpStyle}
            />
            <label
              className={
                privacy != null
                  ? "floating_label_invite_user"
                  : `floating-label`
              }
            >
              {" "}
              Privacy Status{" "}
            </label>
          </div>
          <div className="floating-label-group grp_invite_user_input_item">
            {invitedUsers.length > 0 ? (
              <div className="grp_invite_user_input_invited_users_container">
                {invitedUsers.map((e, idx) => {
                  return (
                    <span
                      key={e.o_id + idx}
                      className="grp_invite_user_input_invited_users"
                    >
                      {profilePicValidityCheck(e.profilePic) ? (
                        <img
                          className="grp_create_search_user_pic"
                          src={e.profilePic}
                        />
                      ) : (
                        <span
                          className="spotlightUserInitials"
                          data-letters={this.getInitials(e)}
                        ></span>
                      )}
                      {e.firstName} {e.lastName ? e.lastName : ""}
                      <i
                        onClick={() => this.removeUser(e)}
                        className="flaticon-trash"
                      />
                    </span>
                  );
                })}
              </div>
            ) : null}
            <input
              type="text"
              id="invitedUsers"
              className="form-control"
              onChange={this.assignedUserDelay}
              value={searchedUser}
              autoComplete="off"
              placeholder=" "
            />
            <label
              className={
                invitedUsers.length > 0
                  ? "floating_label_invite_user"
                  : `floating-label`
              }
            >
              {" "}
              Invite members{" "}
            </label>
            {Array.isArray(users) && users.length > 0 ? (
              <span className="grp_create_search_user_res">
                <div className="divTable">
                  <div className="divTableBody">
                    {users.map((user) => {
                      return (
                        <div
                          className="divTableRow"
                          onClick={() => this.assignedUserFormat(user)}
                          key={user._id + user.organizationId}
                        >
                          <div className="divTableCell">
                            {profilePicValidityCheck(user.profilePic) ? (
                              <img
                                className="grp_create_search_user_pic"
                                src={user.profilePic}
                              />
                            ) : (
                              <span
                                className="spotlightUserInitials"
                                data-letters={this.getInitials(user)}
                              ></span>
                            )}
                            {user.firstName} {user.lastName}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </span>
            ) : null}
          </div>

          {/*------ Description for group -----*/}
          <div className="floating-label-group">
            <textarea
              className={"grp_create_description_txt"}
              placeholder=""
              onKeyPress={this.handleKeyPress}
              onChange={this.handleGrpDesc}
              value={description}
            />
            <label
              className={
                description && description.length > 0
                  ? "floating_label_invite_user"
                  : `floating-label`
              }
            >
              {" "}
              Description{" "}
              {description.length > 0
                ? ` (${description.length}/200 char)`
                : "max 200 char"}{" "}
            </label>
            {isDescErr ? (
              <div className="grp_create_description_error">
                {" "}
                Group description can not exceed 200 characters.{" "}
              </div>
            ) : null}
          </div>

            {/*------ Welcome message for group -----*/}
            <div className="floating-label-group">
            <textarea
              className={"grp_create_description_txt"}
              // placeholder="Write a custom greeting for new users to receive via email"
              onKeyPress={this.handleKeyPress}
              onChange={this.handleGrpWelcomeMessage}
              value={welcomeMessage}
            />
            <label
              className={
                welcomeMessage && welcomeMessage.length > 0
                  ? "floating_label_invite_user"
                  : `floating-label`
              }
            >
              {" "}
              Group welcome message{" "}
              {welcomeMessage.length > 0
                ? ` (${welcomeMessage.length}/200 char)`
                : "max 200 char"}{" "} (optional)
            </label>
            {isWelcomeMsgErr ? (
              <div className="grp_create_description_error">
                {" "}
                Group welcome message can not exceed 200 characters.{" "}
              </div>
            ) : null}
          </div>

          <div className="floating-label-group grp_create_category_container">
            <Select
              name="kpi-select"
              placeholder={""}
              isMulti
              value={selectedCategories.length > 0 ? selectedCategories : ""}
              multi
              isOpen
              onChange={this.addGroupCategory}
              // onChange={cat => this.addGroupCategory(cat)}
              options={groupCategories}
              getOptionLabel={({ name }) => name}
              getOptionValue={({ id }) => id}
              valueKey="id"
              labelKey="name"
              styles={createGrpStyle}
            />
            <label
              className={
                selectedCategories.length > 0
                  ? "floating_label_invite_user"
                  : `floating-label`
              }
            >
              {" "}
              Group types (optional - up to 3)
            </label>
            {isCatErr ? (
              <div className="grp_create_description_error">
                {" "}
                Only choose up to 3 categories.{" "}
              </div>
            ) : null}
            {/* <label className="floating-label">Choose Group categories (optional)</label> */}
          </div>

          <div>
            <AutocompleteAddress
              address={this.state.address}
              handleSelect={(address, lng, lat) => {
                this.setState({
                  address,
                  location: {
                    type: "Point",
                    coordinates: [lng, lat],
                  },
                });
              }}
              relative
              labelComp={
                <label className="floating-label">Address Location</label>
              }
              floatingLabel={true}
            />
          </div>
        </div>

        <div className="custom_left_menu_create_button_container boxShadow2">
          <div className="mt-2">
            <EventsMap
              item={{ location: this.state.location }}
              lefletHeightClass="lh-200"
            />
          </div>
          {errors_array.length > 0 ? (
            <Alert
              className="toolkit_add_page_errors_container mt-2"
              color="danger"
            >
              Please fill in the following:
              <ul>
                {" "}
                {errors_array.map((e, idx) => {
                  return (
                    <li className="toolkit_add_page_errors" key={idx}>
                      {e}
                    </li>
                  );
                })}
              </ul>
            </Alert>
          ) : null}
          <div
            className={
              isCreate
                ? `custom_left_menu_create_button active`
                : `custom_left_menu_create_button`
            }
            onClick={isCreate ? () => this.createGroup() : null}
          >
            Create
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(GroupMenu, axios)));
